import type { MaybeRefOrGetter } from 'vue'
// @ts-expect-error virtual file
import { useSeoMeta } from '#imports'
import { computed, toValue } from 'vue'
import { useLocale } from './locale'

interface Seo {
  title?: MaybeRefOrGetter<string | string[]>
  description?: MaybeRefOrGetter<string>
}

export function useSeo(seo?: Seo) {
  const { t } = useLocale()

  const title = computed(() => {
    const value = toValue(seo?.title)
    if (Array.isArray(value)) {
      return value.join(' • ')
    }
    return value
  })
  const description = computed(() => {
    const value = toValue(seo?.description)
    if (value) {
      return value
    }
    return t('default.meta.description')
  })
  useSeoMeta({
    title,
    ogTitle: title,
    description,
    ogDescription: description,
  })
}
